import { defineMessages } from '@/i18n'

/** Project execution end to end: lifecycle, plan, revenue, output (docs/project-execution-design.md). */
export const executionMessages = defineMessages({
  en: {
    nav: 'Execution',
    loading: 'Loading execution',
    stateOffer: 'Offer', stateNegotiation: 'Negotiation', stateContracted: 'Contracted', stateReady: 'Ready',
    stateIn_progress: 'In progress', stateCompleted: 'Completed', stateAccepted: 'Accepted', stateClosed: 'Closed',
    stateLost: 'Lost', stateCancelled: 'Cancelled',
    reasonPermit: 'Permit', reasonClient: 'Client', reasonMaterial: 'Material', reasonDesign: 'Design / LLD',
    reasonWeather: 'Weather', reasonCrew: 'Crew', reasonOther: 'Other',
    kindTrench: 'Trench · {surface}', kindTrench_total: 'Trench, all surfaces (m)', kindHa: 'HA connections', kindHa_m: 'HA trench (m)', kindHp: 'HP (passive addresses)',
    kindHp_plus: 'HP+', kindNha: 'NHA connections', kindPnha: 'PNHA connections', kindDp: 'DPs placed', kindCrossing: 'Road crossings',
    surfEarth: 'earth', surfSlab: 'slabs', surfPaving: 'paving', surfAsphalt: 'asphalt', surfClinker: 'clinker',
    surfNatural_stone: 'natural stone', surfHansegrand: 'Hansegrand', surfOther: 'other',
    grpAdvance: 'Advances', grpProgress: 'Progress (BIS, HP, HA…)', grpExtra: 'Extra work', grpDamage: 'Damage recharges',
    grpPenalty: 'Penalties', grpFinal: 'Final invoice', grpOther: 'Other',
    panelTitle: 'Execution',
    since: 'since {date}',
    days: '{n} days',
    derivedBadge: 'from AU data',
    derivedHint: 'Derived from AU (contract upload, invoices, crew-days) until the gate is signed in the workflow above.',
    blockedSince: 'Blocked since {date}: {reason}',
    changeState: 'Change state',
    block: 'Block',
    endBlock: 'End block',
    editPlan: 'Plan',
    noTimeline: 'No state yet: AU has no contract, invoice or crew-day for this project.',
    plannedEnd: 'planned end {date}',
    daysLate: '{n} days late',
    onTime: 'on schedule',
    noPlanEnd: 'no planned end',
    blockedDays: '{n} days blocked',
    idle: 'no crew-day for {n} days',
    kpiState: 'In this state',
    kpiInvoiced: 'Invoiced (net)',
    kpiContract: 'of {value} contract',
    kpiNoContract: 'no contract value',
    kpiPaid: 'Paid',
    kpiOwed: 'Owed',
    kpiUnknown: 'Not yet in receivables',
    kpiSchedule: 'Schedule',
    paidAsOf: 'Payments as of {date}, the last receivables import.',
    outputTitle: 'Built',
    colWhat: 'What',
    colBuilt: 'Built',
    colPlanned: 'Planned',
    notRecorded: 'not in daily reports',
    revenueTitle: 'Invoiced by type',
    colType: 'Type',
    colInvoices: 'Invoices',
    colNet: 'Net',
    historyTitle: 'Recorded history',
    blocksTitle: 'Blocked periods',
    delete: 'Delete',
    stillBlocked: 'still blocked',
    by: 'by {name}',
    state: 'State',
    at: 'Date',
    note: 'Note (optional)',
    reason: 'Reason',
    startsOn: 'From',
    endsOn: 'To',
    save: 'Save',
    cancel: 'Cancel',
    planContract: 'Contract value (€)',
    planStart: 'Start',
    planEnd: 'End',
    planActivation: 'Activation',
    planAcceptance: 'Acceptance (Abnahme)',
    planHp: 'HP',
    planHpPlus: 'HP+',
    planHa: 'HA',
    planTrench: 'Trench (m)',
    planHint: "Empty fields fall back to AU's planning values.",
    fromAu: 'from AU',
    portfolioTitle: 'Project execution',
    portfolioSubtitle: 'Every project worked in the last year: where it is in its lifecycle, how long it has been there, what it built and what it earned.',
    tileProjects: 'Projects',
    tileInProgress: 'Active, in progress',
    tileIdle: 'No crew-day 21+ days',
    funnelIdle: '{n} idle',
    tileBlocked: 'Blocked now',
    tileLate: 'Late',
    tileInvoiced: 'Invoiced (net)',
    tileOwed: 'Owed',
    funnelTitle: 'Where the projects are',
    builtTitle: 'Built across these projects',
    timeTitle: 'How long each state takes',
    timeHint: 'Median days of finished stays (bar) and the 75th percentile (tick); net of blocked days in brackets. Projects still in a state are counted separately.',
    timeNone: 'no finished stays yet',
    timeOngoing: '{n} now · median {d} d so far',
    search: 'Project, code, provider…',
    all: 'All',
    colProject: 'Project',
    colState: 'State',
    colDays: 'Days',
    colBlocked: 'Blocked',
    colEnd: 'Planned end',
    colInvoiced: 'Invoiced',
    colPaid: 'Paid',
    colTrench: 'Trench m',
    colHa: 'HA',
    colHpPlus: 'HP+',
    colLastWorked: 'Last worked',
    derivedShort: 'AU',
    derivedLegend: 'AU: state derived from AU data (contract, invoices, crew-days), not yet recorded by an admin.',
    shownOf: '{shown} of {total} projects',
  },
  de: {
    nav: 'Ausführung',
    loading: 'Ausführung wird geladen',
    stateOffer: 'Angebot', stateNegotiation: 'Verhandlung', stateContracted: 'Beauftragt', stateReady: 'Startklar',
    stateIn_progress: 'In Ausführung', stateCompleted: 'Fertiggestellt', stateAccepted: 'Abgenommen', stateClosed: 'Abgeschlossen',
    stateLost: 'Verloren', stateCancelled: 'Storniert',
    reasonPermit: 'Genehmigung', reasonClient: 'Auftraggeber', reasonMaterial: 'Material', reasonDesign: 'Planung / LLD',
    reasonWeather: 'Wetter', reasonCrew: 'Kolonne', reasonOther: 'Sonstiges',
    kindTrench: 'Trasse · {surface}', kindTrench_total: 'Trasse, alle Oberflächen (m)', kindHa: 'HA-Anschlüsse', kindHa_m: 'HA-Trasse (m)', kindHp: 'HP (passive Adressen)',
    kindHp_plus: 'HP+', kindNha: 'NHA-Anschlüsse', kindPnha: 'PNHA-Anschlüsse', kindDp: 'DPs eingebaut', kindCrossing: 'Straßenquerungen',
    surfEarth: 'Erde', surfSlab: 'Platte', surfPaving: 'Pflaster', surfAsphalt: 'Asphalt', surfClinker: 'Klinker',
    surfNatural_stone: 'Naturstein', surfHansegrand: 'Hansegrand', surfOther: 'Sonstige',
    grpAdvance: 'Vorschüsse', grpProgress: 'Leistung (BIS, HP, HA…)', grpExtra: 'Mehraufwand', grpDamage: 'Schadensweiterberechnung',
    grpPenalty: 'Vertragsstrafen', grpFinal: 'Schlussrechnung', grpOther: 'Sonstige',
    panelTitle: 'Ausführung',
    since: 'seit {date}',
    days: '{n} Tage',
    derivedBadge: 'aus AU-Daten',
    derivedHint: 'Aus AU abgeleitet (Vertrags-Upload, Rechnungen, Kolonnentage), bis das Tor im Ablauf oben unterschrieben ist.',
    blockedSince: 'Blockiert seit {date}: {reason}',
    changeState: 'Phase ändern',
    block: 'Blockieren',
    endBlock: 'Blockade beenden',
    editPlan: 'Plan',
    noTimeline: 'Noch keine Phase: AU hat für dieses Projekt keinen Vertrag, keine Rechnung und keinen Kolonnentag.',
    plannedEnd: 'Planende {date}',
    daysLate: '{n} Tage Verzug',
    onTime: 'im Plan',
    noPlanEnd: 'kein Planende',
    blockedDays: '{n} Tage blockiert',
    idle: 'seit {n} Tagen kein Kolonnentag',
    kpiState: 'In dieser Phase',
    kpiInvoiced: 'Fakturiert (netto)',
    kpiContract: 'von {value} Auftragswert',
    kpiNoContract: 'kein Auftragswert',
    kpiPaid: 'Bezahlt',
    kpiOwed: 'Offen',
    kpiUnknown: 'Noch nicht in OP-Liste',
    kpiSchedule: 'Termin',
    paidAsOf: 'Zahlungen Stand {date}, letzter OP-Import.',
    outputTitle: 'Gebaut',
    colWhat: 'Was',
    colBuilt: 'Gebaut',
    colPlanned: 'Geplant',
    notRecorded: 'nicht im Aufmaß erfasst',
    revenueTitle: 'Fakturiert nach Art',
    colType: 'Art',
    colInvoices: 'Rechnungen',
    colNet: 'Netto',
    historyTitle: 'Erfasster Verlauf',
    blocksTitle: 'Blockaden',
    delete: 'Löschen',
    stillBlocked: 'noch blockiert',
    by: 'von {name}',
    state: 'Phase',
    at: 'Datum',
    note: 'Notiz (optional)',
    reason: 'Grund',
    startsOn: 'Von',
    endsOn: 'Bis',
    save: 'Speichern',
    cancel: 'Abbrechen',
    planContract: 'Auftragswert (€)',
    planStart: 'Beginn',
    planEnd: 'Ende',
    planActivation: 'Aktivierung',
    planAcceptance: 'Abnahme',
    planHp: 'HP',
    planHpPlus: 'HP+',
    planHa: 'HA',
    planTrench: 'Trasse (m)',
    planHint: 'Leere Felder übernehmen die Planwerte aus AU.',
    fromAu: 'aus AU',
    portfolioTitle: 'Projektausführung',
    portfolioSubtitle: 'Jedes Projekt mit Arbeit im letzten Jahr: wo es im Ablauf steht, wie lange schon, was gebaut und was fakturiert wurde.',
    tileProjects: 'Projekte',
    tileInProgress: 'Aktiv in Ausführung',
    tileIdle: 'Seit 21+ Tagen ohne Kolonne',
    funnelIdle: '{n} ruhen',
    tileBlocked: 'Aktuell blockiert',
    tileLate: 'Im Verzug',
    tileInvoiced: 'Fakturiert (netto)',
    tileOwed: 'Offen',
    funnelTitle: 'Wo die Projekte stehen',
    builtTitle: 'Gebaut in diesen Projekten',
    timeTitle: 'Wie lange jede Phase dauert',
    timeHint: 'Median der abgeschlossenen Phasen in Tagen (Balken) und 75. Perzentil (Strich); ohne Blockadetage in Klammern. Laufende Projekte separat.',
    timeNone: 'noch keine abgeschlossene Phase',
    timeOngoing: '{n} aktuell · Median bisher {d} T',
    search: 'Projekt, Nummer, Netzbetreiber…',
    all: 'Alle',
    colProject: 'Projekt',
    colState: 'Phase',
    colDays: 'Tage',
    colBlocked: 'Blockiert',
    colEnd: 'Planende',
    colInvoiced: 'Fakturiert',
    colPaid: 'Bezahlt',
    colTrench: 'Trasse m',
    colHa: 'HA',
    colHpPlus: 'HP+',
    colLastWorked: 'Zuletzt gearbeitet',
    derivedShort: 'AU',
    derivedLegend: 'AU: Phase aus AU-Daten abgeleitet (Vertrag, Rechnungen, Kolonnentage), noch nicht von einem Admin erfasst.',
    shownOf: '{shown} von {total} Projekten',
  },
  cnr: {
    nav: 'Izvođenje',
    loading: 'Učitavanje izvođenja',
    stateOffer: 'Ponuda', stateNegotiation: 'Pregovori', stateContracted: 'Ugovoreno', stateReady: 'Spremno',
    stateIn_progress: 'U izvođenju', stateCompleted: 'Završeno', stateAccepted: 'Primljeno', stateClosed: 'Zatvoreno',
    stateLost: 'Izgubljeno', stateCancelled: 'Otkazano',
    reasonPermit: 'Dozvola', reasonClient: 'Naručilac', reasonMaterial: 'Materijal', reasonDesign: 'Projekat / LLD',
    reasonWeather: 'Vrijeme', reasonCrew: 'Kolona', reasonOther: 'Ostalo',
    kindTrench: 'Trasa · {surface}', kindTrench_total: 'Trasa, sve površine (m)', kindHa: 'HA priključci', kindHa_m: 'HA trasa (m)', kindHp: 'HP (pasivne adrese)',
    kindHp_plus: 'HP+', kindNha: 'NHA priključci', kindPnha: 'PNHA priključci', kindDp: 'Postavljeni DP-ovi', kindCrossing: 'Prekopi ulica',
    surfEarth: 'zemlja', surfSlab: 'ploče', surfPaving: 'flasta', surfAsphalt: 'asfalt', surfClinker: 'sitna flasta',
    surfNatural_stone: 'mozaik', surfHansegrand: 'Hansegrand', surfOther: 'ostalo',
    grpAdvance: 'Avansi', grpProgress: 'Učinak (BIS, HP, HA…)', grpExtra: 'Dodatni radovi', grpDamage: 'Naknada štete',
    grpPenalty: 'Penali', grpFinal: 'Konačna faktura', grpOther: 'Ostalo',
    panelTitle: 'Izvođenje',
    since: 'od {date}',
    days: '{n} dana',
    derivedBadge: 'iz AU podataka',
    derivedHint: 'Izvedeno iz AU (upload ugovora, fakture, dani kolona) dok se kapija ne potpiše u toku projekta iznad.',
    blockedSince: 'Blokirano od {date}: {reason}',
    changeState: 'Promijeni fazu',
    block: 'Blokiraj',
    endBlock: 'Završi blokadu',
    editPlan: 'Plan',
    noTimeline: 'Još nema faze: AU nema ugovor, fakturu ni dan kolone za ovaj projekat.',
    plannedEnd: 'planirani kraj {date}',
    daysLate: '{n} dana kašnjenja',
    onTime: 'u roku',
    noPlanEnd: 'nema planiranog kraja',
    blockedDays: '{n} dana blokirano',
    idle: 'bez rada {n} dana',
    kpiState: 'U ovoj fazi',
    kpiInvoiced: 'Fakturisano (neto)',
    kpiContract: 'od {value} ugovora',
    kpiNoContract: 'nema vrijednosti ugovora',
    kpiPaid: 'Plaćeno',
    kpiOwed: 'Dug',
    kpiUnknown: 'Još nije u potraživanjima',
    kpiSchedule: 'Rok',
    paidAsOf: 'Plaćanja na dan {date}, posljednji uvoz potraživanja.',
    outputTitle: 'Izgrađeno',
    colWhat: 'Šta',
    colBuilt: 'Izgrađeno',
    colPlanned: 'Planirano',
    notRecorded: 'nema u Aufmaßu',
    revenueTitle: 'Fakturisano po vrsti',
    colType: 'Vrsta',
    colInvoices: 'Fakture',
    colNet: 'Neto',
    historyTitle: 'Upisana istorija',
    blocksTitle: 'Blokade',
    delete: 'Obriši',
    stillBlocked: 'još blokirano',
    by: 'upisao {name}',
    state: 'Faza',
    at: 'Datum',
    note: 'Napomena (neobavezno)',
    reason: 'Razlog',
    startsOn: 'Od',
    endsOn: 'Do',
    save: 'Sačuvaj',
    cancel: 'Otkaži',
    planContract: 'Vrijednost ugovora (€)',
    planStart: 'Početak',
    planEnd: 'Kraj',
    planActivation: 'Aktivacija',
    planAcceptance: 'Prijem (Abnahme)',
    planHp: 'HP',
    planHpPlus: 'HP+',
    planHa: 'HA',
    planTrench: 'Trasa (m)',
    planHint: 'Prazna polja preuzimaju planske vrijednosti iz AU.',
    fromAu: 'iz AU',
    portfolioTitle: 'Izvođenje projekata',
    portfolioSubtitle: 'Svaki projekat s radom u posljednjoj godini: gdje je u toku, koliko dugo, šta je izgrađeno i šta je fakturisano.',
    tileProjects: 'Projekti',
    tileInProgress: 'Aktivno u izvođenju',
    tileIdle: 'Bez rada 21+ dana',
    funnelIdle: '{n} bez rada',
    tileBlocked: 'Trenutno blokirani',
    tileLate: 'Kasne',
    tileInvoiced: 'Fakturisano (neto)',
    tileOwed: 'Dug',
    funnelTitle: 'Gdje su projekti',
    builtTitle: 'Izgrađeno na ovim projektima',
    timeTitle: 'Koliko traje svaka faza',
    timeHint: 'Medijana dana završenih faza (traka) i 75. percentil (crtica); bez dana blokade u zagradi. Projekti koji su još u fazi broje se posebno.',
    timeNone: 'još nema završene faze',
    timeOngoing: '{n} sada · medijana dosad {d} d',
    search: 'Projekat, šifra, naručilac…',
    all: 'Svi',
    colProject: 'Projekat',
    colState: 'Faza',
    colDays: 'Dana',
    colBlocked: 'Blokirano',
    colEnd: 'Plan. kraj',
    colInvoiced: 'Fakturisano',
    colPaid: 'Plaćeno',
    colTrench: 'Trasa m',
    colHa: 'HA',
    colHpPlus: 'HP+',
    colLastWorked: 'Posljednji rad',
    derivedShort: 'AU',
    derivedLegend: 'AU: faza izvedena iz AU podataka (ugovor, fakture, dani kolona), admin je još nije upisao.',
    shownOf: '{shown} od {total} projekata',
  },
  bs: {
    nav: 'Izvođenje',
    loading: 'Učitavanje izvođenja',
    stateOffer: 'Ponuda', stateNegotiation: 'Pregovori', stateContracted: 'Ugovoreno', stateReady: 'Spremno',
    stateIn_progress: 'U izvođenju', stateCompleted: 'Završeno', stateAccepted: 'Primljeno', stateClosed: 'Zatvoreno',
    stateLost: 'Izgubljeno', stateCancelled: 'Otkazano',
    reasonPermit: 'Dozvola', reasonClient: 'Naručilac', reasonMaterial: 'Materijal', reasonDesign: 'Projekat / LLD',
    reasonWeather: 'Vrijeme', reasonCrew: 'Kolona', reasonOther: 'Ostalo',
    kindTrench: 'Trasa · {surface}', kindTrench_total: 'Trasa, sve površine (m)', kindHa: 'HA priključci', kindHa_m: 'HA trasa (m)', kindHp: 'HP (pasivne adrese)',
    kindHp_plus: 'HP+', kindNha: 'NHA priključci', kindPnha: 'PNHA priključci', kindDp: 'Postavljeni DP-ovi', kindCrossing: 'Prekopi ulica',
    surfEarth: 'zemlja', surfSlab: 'ploče', surfPaving: 'flasta', surfAsphalt: 'asfalt', surfClinker: 'sitna flasta',
    surfNatural_stone: 'mozaik', surfHansegrand: 'Hansegrand', surfOther: 'ostalo',
    grpAdvance: 'Avansi', grpProgress: 'Učinak (BIS, HP, HA…)', grpExtra: 'Dodatni radovi', grpDamage: 'Naknada štete',
    grpPenalty: 'Penali', grpFinal: 'Konačna faktura', grpOther: 'Ostalo',
    panelTitle: 'Izvođenje',
    since: 'od {date}',
    days: '{n} dana',
    derivedBadge: 'iz AU podataka',
    derivedHint: 'Izvedeno iz AU (upload ugovora, fakture, dani kolona) dok se kapija ne potpiše u toku projekta iznad.',
    blockedSince: 'Blokirano od {date}: {reason}',
    changeState: 'Promijeni fazu',
    block: 'Blokiraj',
    endBlock: 'Završi blokadu',
    editPlan: 'Plan',
    noTimeline: 'Još nema faze: AU nema ugovor, fakturu ni dan kolone za ovaj projekat.',
    plannedEnd: 'planirani kraj {date}',
    daysLate: '{n} dana kašnjenja',
    onTime: 'u roku',
    noPlanEnd: 'nema planiranog kraja',
    blockedDays: '{n} dana blokirano',
    idle: 'bez rada {n} dana',
    kpiState: 'U ovoj fazi',
    kpiInvoiced: 'Fakturisano (neto)',
    kpiContract: 'od {value} ugovora',
    kpiNoContract: 'nema vrijednosti ugovora',
    kpiPaid: 'Plaćeno',
    kpiOwed: 'Dug',
    kpiUnknown: 'Još nije u potraživanjima',
    kpiSchedule: 'Rok',
    paidAsOf: 'Plaćanja na dan {date}, posljednji uvoz potraživanja.',
    outputTitle: 'Izgrađeno',
    colWhat: 'Šta',
    colBuilt: 'Izgrađeno',
    colPlanned: 'Planirano',
    notRecorded: 'nema u Aufmaßu',
    revenueTitle: 'Fakturisano po vrsti',
    colType: 'Vrsta',
    colInvoices: 'Fakture',
    colNet: 'Neto',
    historyTitle: 'Upisana historija',
    blocksTitle: 'Blokade',
    delete: 'Obriši',
    stillBlocked: 'još blokirano',
    by: 'upisao {name}',
    state: 'Faza',
    at: 'Datum',
    note: 'Napomena (neobavezno)',
    reason: 'Razlog',
    startsOn: 'Od',
    endsOn: 'Do',
    save: 'Spasi',
    cancel: 'Otkaži',
    planContract: 'Vrijednost ugovora (€)',
    planStart: 'Početak',
    planEnd: 'Kraj',
    planActivation: 'Aktivacija',
    planAcceptance: 'Prijem (Abnahme)',
    planHp: 'HP',
    planHpPlus: 'HP+',
    planHa: 'HA',
    planTrench: 'Trasa (m)',
    planHint: 'Prazna polja preuzimaju planske vrijednosti iz AU.',
    fromAu: 'iz AU',
    portfolioTitle: 'Izvođenje projekata',
    portfolioSubtitle: 'Svaki projekat s radom u posljednjoj godini: gdje je u toku, koliko dugo, šta je izgrađeno i šta je fakturisano.',
    tileProjects: 'Projekti',
    tileInProgress: 'Aktivno u izvođenju',
    tileIdle: 'Bez rada 21+ dana',
    funnelIdle: '{n} bez rada',
    tileBlocked: 'Trenutno blokirani',
    tileLate: 'Kasne',
    tileInvoiced: 'Fakturisano (neto)',
    tileOwed: 'Dug',
    funnelTitle: 'Gdje su projekti',
    builtTitle: 'Izgrađeno na ovim projektima',
    timeTitle: 'Koliko traje svaka faza',
    timeHint: 'Medijana dana završenih faza (traka) i 75. percentil (crtica); bez dana blokade u zagradi. Projekti koji su još u fazi broje se posebno.',
    timeNone: 'još nema završene faze',
    timeOngoing: '{n} sada · medijana dosad {d} d',
    search: 'Projekat, šifra, naručilac…',
    all: 'Svi',
    colProject: 'Projekat',
    colState: 'Faza',
    colDays: 'Dana',
    colBlocked: 'Blokirano',
    colEnd: 'Plan. kraj',
    colInvoiced: 'Fakturisano',
    colPaid: 'Plaćeno',
    colTrench: 'Trasa m',
    colHa: 'HA',
    colHpPlus: 'HP+',
    colLastWorked: 'Posljednji rad',
    derivedShort: 'AU',
    derivedLegend: 'AU: faza izvedena iz AU podataka (ugovor, fakture, dani kolona), admin je još nije upisao.',
    shownOf: '{shown} od {total} projekata',
  },
  sr: {
    nav: 'Izvođenje',
    loading: 'Učitavanje izvođenja',
    stateOffer: 'Ponuda', stateNegotiation: 'Pregovori', stateContracted: 'Ugovoreno', stateReady: 'Spremno',
    stateIn_progress: 'U izvođenju', stateCompleted: 'Završeno', stateAccepted: 'Primljeno', stateClosed: 'Zatvoreno',
    stateLost: 'Izgubljeno', stateCancelled: 'Otkazano',
    reasonPermit: 'Dozvola', reasonClient: 'Naručilac', reasonMaterial: 'Materijal', reasonDesign: 'Projekat / LLD',
    reasonWeather: 'Vreme', reasonCrew: 'Kolona', reasonOther: 'Ostalo',
    kindTrench: 'Trasa · {surface}', kindTrench_total: 'Trasa, sve površine (m)', kindHa: 'HA priključci', kindHa_m: 'HA trasa (m)', kindHp: 'HP (pasivne adrese)',
    kindHp_plus: 'HP+', kindNha: 'NHA priključci', kindPnha: 'PNHA priključci', kindDp: 'Postavljeni DP-ovi', kindCrossing: 'Prekopi ulica',
    surfEarth: 'zemlja', surfSlab: 'ploče', surfPaving: 'flasta', surfAsphalt: 'asfalt', surfClinker: 'sitna flasta',
    surfNatural_stone: 'mozaik', surfHansegrand: 'Hansegrand', surfOther: 'ostalo',
    grpAdvance: 'Avansi', grpProgress: 'Učinak (BIS, HP, HA…)', grpExtra: 'Dodatni radovi', grpDamage: 'Naknada štete',
    grpPenalty: 'Penali', grpFinal: 'Konačna faktura', grpOther: 'Ostalo',
    panelTitle: 'Izvođenje',
    since: 'od {date}',
    days: '{n} dana',
    derivedBadge: 'iz AU podataka',
    derivedHint: 'Izvedeno iz AU (upload ugovora, fakture, dani kolona) dok se kapija ne potpiše u toku projekta iznad.',
    blockedSince: 'Blokirano od {date}: {reason}',
    changeState: 'Promeni fazu',
    block: 'Blokiraj',
    endBlock: 'Završi blokadu',
    editPlan: 'Plan',
    noTimeline: 'Još nema faze: AU nema ugovor, fakturu ni dan kolone za ovaj projekat.',
    plannedEnd: 'planirani kraj {date}',
    daysLate: '{n} dana kašnjenja',
    onTime: 'u roku',
    noPlanEnd: 'nema planiranog kraja',
    blockedDays: '{n} dana blokirano',
    idle: 'bez rada {n} dana',
    kpiState: 'U ovoj fazi',
    kpiInvoiced: 'Fakturisano (neto)',
    kpiContract: 'od {value} ugovora',
    kpiNoContract: 'nema vrednosti ugovora',
    kpiPaid: 'Plaćeno',
    kpiOwed: 'Dug',
    kpiUnknown: 'Još nije u potraživanjima',
    kpiSchedule: 'Rok',
    paidAsOf: 'Plaćanja na dan {date}, poslednji uvoz potraživanja.',
    outputTitle: 'Izgrađeno',
    colWhat: 'Šta',
    colBuilt: 'Izgrađeno',
    colPlanned: 'Planirano',
    notRecorded: 'nema u Aufmaßu',
    revenueTitle: 'Fakturisano po vrsti',
    colType: 'Vrsta',
    colInvoices: 'Fakture',
    colNet: 'Neto',
    historyTitle: 'Upisana istorija',
    blocksTitle: 'Blokade',
    delete: 'Obriši',
    stillBlocked: 'još blokirano',
    by: 'upisao {name}',
    state: 'Faza',
    at: 'Datum',
    note: 'Napomena (neobavezno)',
    reason: 'Razlog',
    startsOn: 'Od',
    endsOn: 'Do',
    save: 'Sačuvaj',
    cancel: 'Otkaži',
    planContract: 'Vrednost ugovora (€)',
    planStart: 'Početak',
    planEnd: 'Kraj',
    planActivation: 'Aktivacija',
    planAcceptance: 'Prijem (Abnahme)',
    planHp: 'HP',
    planHpPlus: 'HP+',
    planHa: 'HA',
    planTrench: 'Trasa (m)',
    planHint: 'Prazna polja preuzimaju planske vrednosti iz AU.',
    fromAu: 'iz AU',
    portfolioTitle: 'Izvođenje projekata',
    portfolioSubtitle: 'Svaki projekat sa radom u poslednjoj godini: gde je u toku, koliko dugo, šta je izgrađeno i šta je fakturisano.',
    tileProjects: 'Projekti',
    tileInProgress: 'Aktivno u izvođenju',
    tileIdle: 'Bez rada 21+ dana',
    funnelIdle: '{n} bez rada',
    tileBlocked: 'Trenutno blokirani',
    tileLate: 'Kasne',
    tileInvoiced: 'Fakturisano (neto)',
    tileOwed: 'Dug',
    funnelTitle: 'Gde su projekti',
    builtTitle: 'Izgrađeno na ovim projektima',
    timeTitle: 'Koliko traje svaka faza',
    timeHint: 'Medijana dana završenih faza (traka) i 75. percentil (crtica); bez dana blokade u zagradi. Projekti koji su još u fazi broje se posebno.',
    timeNone: 'još nema završene faze',
    timeOngoing: '{n} sada · medijana dosad {d} d',
    search: 'Projekat, šifra, naručilac…',
    all: 'Svi',
    colProject: 'Projekat',
    colState: 'Faza',
    colDays: 'Dana',
    colBlocked: 'Blokirano',
    colEnd: 'Plan. kraj',
    colInvoiced: 'Fakturisano',
    colPaid: 'Plaćeno',
    colTrench: 'Trasa m',
    colHa: 'HA',
    colHpPlus: 'HP+',
    colLastWorked: 'Poslednji rad',
    derivedShort: 'AU',
    derivedLegend: 'AU: faza izvedena iz AU podataka (ugovor, fakture, dani kolona), admin je još nije upisao.',
    shownOf: '{shown} od {total} projekata',
  },
})
